import { render, staticRenderFns } from "./FilterManagement.vue?vue&type=template&id=20a0728c&"
import script from "./FilterManagement.vue?vue&type=script&lang=js&"
export * from "./FilterManagement.vue?vue&type=script&lang=js&"
import style0 from "./FilterManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports